export default __webpack_public_path__ + "static/media/suite-montanha1-6.48bcb1ca.jpg";